import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

export default function CookiePolicy() {
  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />
      
      <div className="pt-24 pb-16">
        <div className="container mx-auto px-4 md:px-6 max-w-4xl">
          <div className="bg-white rounded-3xl shadow-lg border border-slate-200 p-8 md:p-12">
            <h1 className="text-3xl md:text-4xl font-bold text-[#0f172a] mb-8" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Cookie Policy
            </h1>
            
            <div className="prose prose-slate max-w-none">
              <p className="text-slate-600 mb-6">
                <strong>Last Updated:</strong> March 2026
              </p>
              
              <p className="text-slate-600 mb-6">
                This Cookie Policy explains how Local Tradies Online ("we", "our", or "us") uses cookies and similar technologies when you visit our website localtradiesonline.com.au.
              </p>

              <h2 className="text-2xl font-bold text-[#0f172a] mt-8 mb-4">1. What Are Cookies?</h2>
              <p className="text-slate-600 mb-4">
                Cookies are small text files that are placed on your device (computer, tablet, or mobile phone) when you visit a website. They are widely used to make websites work more efficiently and provide information to website owners.
              </p>

              <h2 className="text-2xl font-bold text-[#0f172a] mt-8 mb-4">2. Types of Cookies We Use</h2>
              
              <h3 className="text-xl font-semibold text-[#0f172a] mt-6 mb-3">Essential Cookies</h3>
              <p className="text-slate-600 mb-4">
                These cookies are necessary for the website to function properly. They enable core functionality such as security, network management, and accessibility. You cannot opt out of these cookies.
              </p>
              <table className="w-full border-collapse border border-slate-300 mb-4">
                <thead>
                  <tr className="bg-slate-100">
                    <th className="border border-slate-300 p-2 text-left">Cookie Name</th>
                    <th className="border border-slate-300 p-2 text-left">Purpose</th>
                    <th className="border border-slate-300 p-2 text-left">Duration</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border border-slate-300 p-2">session_id</td>
                    <td className="border border-slate-300 p-2">Maintains user session</td>
                    <td className="border border-slate-300 p-2">Session</td>
                  </tr>
                  <tr>
                    <td className="border border-slate-300 p-2">csrf_token</td>
                    <td className="border border-slate-300 p-2">Security protection</td>
                    <td className="border border-slate-300 p-2">Session</td>
                  </tr>
                </tbody>
              </table>

              <h3 className="text-xl font-semibold text-[#0f172a] mt-6 mb-3">Performance Cookies</h3>
              <p className="text-slate-600 mb-4">
                These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously. This helps us improve the website's performance.
              </p>
              <table className="w-full border-collapse border border-slate-300 mb-4">
                <thead>
                  <tr className="bg-slate-100">
                    <th className="border border-slate-300 p-2 text-left">Cookie Name</th>
                    <th className="border border-slate-300 p-2 text-left">Purpose</th>
                    <th className="border border-slate-300 p-2 text-left">Duration</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border border-slate-300 p-2">_ga</td>
                    <td className="border border-slate-300 p-2">Google Analytics - distinguishes users</td>
                    <td className="border border-slate-300 p-2">2 years</td>
                  </tr>
                  <tr>
                    <td className="border border-slate-300 p-2">_gid</td>
                    <td className="border border-slate-300 p-2">Google Analytics - distinguishes users</td>
                    <td className="border border-slate-300 p-2">24 hours</td>
                  </tr>
                </tbody>
              </table>

              <h3 className="text-xl font-semibold text-[#0f172a] mt-6 mb-3">Functionality Cookies</h3>
              <p className="text-slate-600 mb-4">
                These cookies enable enhanced functionality and personalisation, such as remembering your preferences and settings.
              </p>
              <table className="w-full border-collapse border border-slate-300 mb-4">
                <thead>
                  <tr className="bg-slate-100">
                    <th className="border border-slate-300 p-2 text-left">Cookie Name</th>
                    <th className="border border-slate-300 p-2 text-left">Purpose</th>
                    <th className="border border-slate-300 p-2 text-left">Duration</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border border-slate-300 p-2">user_location</td>
                    <td className="border border-slate-300 p-2">Remembers your location preference</td>
                    <td className="border border-slate-300 p-2">30 days</td>
                  </tr>
                  <tr>
                    <td className="border border-slate-300 p-2">recent_searches</td>
                    <td className="border border-slate-300 p-2">Stores recent search history</td>
                    <td className="border border-slate-300 p-2">7 days</td>
                  </tr>
                </tbody>
              </table>

              <h2 className="text-2xl font-bold text-[#0f172a] mt-8 mb-4">3. Third-Party Cookies</h2>
              <p className="text-slate-600 mb-4">
                Some cookies are placed by third-party services that appear on our pages. We use the following third-party services:
              </p>
              <ul className="list-disc pl-6 text-slate-600 mb-4">
                <li><strong>Google Analytics:</strong> To analyse website traffic and usage patterns</li>
                <li><strong>Google Maps:</strong> To display location information for tradies</li>
              </ul>

              <h2 className="text-2xl font-bold text-[#0f172a] mt-8 mb-4">4. Managing Cookies</h2>
              <p className="text-slate-600 mb-4">
                You can control and manage cookies in several ways:
              </p>
              
              <h3 className="text-xl font-semibold text-[#0f172a] mt-6 mb-3">Browser Settings</h3>
              <p className="text-slate-600 mb-4">
                Most web browsers allow you to manage cookies through their settings. You can:
              </p>
              <ul className="list-disc pl-6 text-slate-600 mb-4">
                <li>View cookies stored on your device</li>
                <li>Delete all or specific cookies</li>
                <li>Block cookies from specific or all websites</li>
                <li>Set preferences for certain types of cookies</li>
              </ul>
              <p className="text-slate-600 mb-4">
                Please note that blocking certain cookies may impact your experience on our website.
              </p>

              <h3 className="text-xl font-semibold text-[#0f172a] mt-6 mb-3">Browser-Specific Instructions</h3>
              <ul className="list-disc pl-6 text-slate-600 mb-4">
                <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="text-[#f97316] hover:underline">Google Chrome</a></li>
                <li><a href="https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer" target="_blank" rel="noopener noreferrer" className="text-[#f97316] hover:underline">Mozilla Firefox</a></li>
                <li><a href="https://support.apple.com/en-au/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" className="text-[#f97316] hover:underline">Safari</a></li>
                <li><a href="https://support.microsoft.com/en-us/microsoft-edge/delete-cookies-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer" className="text-[#f97316] hover:underline">Microsoft Edge</a></li>
              </ul>

              <h2 className="text-2xl font-bold text-[#0f172a] mt-8 mb-4">5. Changes to This Policy</h2>
              <p className="text-slate-600 mb-4">
                We may update this Cookie Policy from time to time to reflect changes in our practices or for other operational, legal, or regulatory reasons. We encourage you to review this policy periodically.
              </p>

              <h2 className="text-2xl font-bold text-[#0f172a] mt-8 mb-4">6. Contact Us</h2>
              <p className="text-slate-600 mb-4">
                If you have any questions about our use of cookies, please contact us at:
              </p>
              <p className="text-slate-600 mb-4">
                <strong>Email:</strong> privacy@localtradiesonline.com.au<br />
                <strong>Phone:</strong> 0431 775 771
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
